import React from 'react'

import {
  RecipeAllergens,
  RecipeIngredientIncluded,
} from '@library/api-menu-experience/src/interfaces/recipe'

import { SectionPanel } from 'routes/Menu/components/SpicyDetail/SectionPanel'

import { IngredientsContain } from '../IngredientsContain/IngredientsContain'
import { Allergens } from './Allergens'

type RecipeIngredientsAllergensProps = {
  allergens?: RecipeAllergens
  includedIngredients?: RecipeIngredientIncluded[]
  loading: boolean
}

export const RecipeIngredientsAllergens = ({
  allergens,
  includedIngredients,
  loading,
}: RecipeIngredientsAllergensProps) => {
  if (loading || includedIngredients?.length === 0) {
    return null
  }

  const allergenNames = allergens?.list.map((allergen) => allergen.name) ?? []

  return (
    <SectionPanel data-testing="recipeDetailsAllergenList">
      <IngredientsContain includedIngredients={includedIngredients} />
      <Allergens allergens={allergenNames} />
    </SectionPanel>
  )
}
